import { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import { api, formatApiError } from "@/api/client";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { SeaServiceEditor } from "@/components/SeaServiceEditor";

export function SeaProfile({ info, meta, onSaved }) {
  const [f, setF] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { setF({ ...info.sea_profile, dob: info.sea_profile.dob || "", sea_service: info.sea_profile.sea_service || [] }); }, [info]);
  if (!f) return null;
  const can = info.can.edit_profile;
  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/candidates/${info.cid}/sea-profile`, { ...f, dob: f.dob || null });
      toast.success("Sea service saved");
      onSaved();
    } catch (err) { toast.error(formatApiError(err)); } finally { setSaving(false); }
  };
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-5 space-y-5" data-testid="sea-profile">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-2xl">
        <div className="space-y-1.5"><Label htmlFor="sp-dob">Date of birth</Label>
          <Input id="sp-dob" type="date" disabled={!can} value={f.dob} onChange={(e) => setF({ ...f, dob: e.target.value })} data-testid="sea-profile-dob-input" /></div>
        <div className="space-y-1.5 sm:col-span-2"><Label htmlFor="sp-nat">Nationality</Label>
          <Input id="sp-nat" disabled={!can} value={f.nationality} placeholder="e.g. Indian" onChange={(e) => setF({ ...f, nationality: e.target.value })} data-testid="sea-profile-nationality-input" /></div>
      </div>
      <div>
        <div className="text-sm font-semibold text-slate-800 mb-2">Sea service experience</div>
        <fieldset disabled={!can} className="min-w-0"><SeaServiceEditor rows={f.sea_service} onChange={(rows) => setF({ ...f, sea_service: rows })} ranks={meta.ranks} vesselTypes={meta.vessel_types} prefix="sea-profile" /></fieldset>
      </div>
      {can && <Button onClick={save} disabled={saving} className="bg-[#0b192c] hover:bg-[#0f2544]" data-testid="sea-profile-save-btn">{saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Save className="w-4 h-4 mr-1" /> Save sea service</>}</Button>}
    </div>
  );
}
